import React, { Component } from 'react';
import _ from 'lodash';

import { MoreVert as MoreVertIcon ,ChevronRight } from '@material-ui/icons';

import { withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import {
	WithStyles,
    createStyles,
    Menu,
    MenuItem,
    Typography
} from '@material-ui/core';
import { MyPATLink } from '../../common';


import { MyPATPopMenu, MenuData } from '../../common';

const styles = createStyles({

});

interface ContentTopMenuProps extends WithStyles<typeof styles> {
    clicked?: Function
}
interface ContentTopMenuState {
}

class MoreVertModalss extends Component<ContentTopMenuProps, ContentTopMenuState>{
    menuItems: MenuData[] = [
    
    ];

    constructor(props: ContentTopMenuProps, state: ContentTopMenuState) {
        super(props);
        // this.clicked = this.clicked.bind(this);
    }
    
    clicked(item : any){
        if(this.props.clicked){
            this.props.clicked(item.text);
        }
    }

	render() {

		return ( 
            <div style={{pointerEvents:"none"}}>
                <MyPATPopMenu  icon={MoreVertIcon} menuItem={this.menuItems} clicked={this.clicked} style={{pointerEvents:"none"}}/>    
            </div>
         
    );
	}
}


// @ts-ignore
export default withStyles(styles)(MoreVertModalss);